import './StoreConfiguresPage.less';

export const prefix = 'bm-p-store-configures';

export { default } from './StoreConfiguresPage';
